import { ACTIVE_USERS_LIST_TAG, api } from '@/api';
import { handleQueryLifecycle } from '../utils';

export type BulkAddUsersTemplateResponse = {
  csv: string;
};

export type BulkAddUsersResponse = {
  userIds: string[];
};

type BulkAddUsersProps = {
  csvString: string;
};

const bulkAddUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBulkAddUsersTemplate: builder.query<BulkAddUsersTemplateResponse, void>({
      query: () => ({
        url: 'users/bulk-add-template',
        method: 'GET',
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
    postBulkAddUsers: builder.query<BulkAddUsersResponse, BulkAddUsersProps>({
      // `csvString` is read from the query string — the endpoint ignores a JSON
      // body and rejects the request as missing the field.
      query: ({ csvString }: BulkAddUsersProps) => ({
        url: 'users/bulk-add',
        method: 'POST',
        params: { csvString },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetBulkAddUsersTemplateQuery, useLazyPostBulkAddUsersQuery } = bulkAddUsersApi;
